import errorManager from '@/rollbar.js';
class SiadDataFineCura {
  constructor(modal_new) {
    this.modal_new = modal_new;
  }

  setListeners() {
    const thisClass = this;
    // as soon as NEW FORM is loaded, calculate the estimated end date
    $(this.modal_new).on('shown.bs.modal', function () {
      thisClass.updateDataFineCuraPrevista();
    });
  }

  updateDataFineCuraPrevista(siad_id) {
    let data, durata, $data_fine_prevista_field;

    if (siad_id != undefined) {
      data = $('#siad4_data_inizio_profilo_cura_' + siad_id).val();
      durata = parseInt($('#siad4_durata_' + siad_id).val());
      $data_fine_prevista_field = $('.data_fine_profilo_cura_prevista_' + siad_id);
    } else {
      data = $('#siad4_data_inizio_profilo_cura_new').val();
      durata = parseInt($('#siad4_durata_new').val());
      $data_fine_prevista_field = $('.data_fine_profilo_cura_prevista_new');
    }

    if (data == '' || durata == '' || durata < 0) {
      return false;
    }

    var fine_prevista = moment(data, 'DD-MM-YYYY')
      .add(durata - 1, 'days')
      .format(i18nJS.time.formats.date_only);
    $data_fine_prevista_field.html(fine_prevista);
  }
}

const init = (modal_new) => {
  try {
    return new SiadDataFineCura(modal_new);
  } catch (e) {
    errorManager(e);
  }
};

window.SiadFineCura = {
  init: init,
};
